/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * DropdownIcon component - Icon for dropdown question type
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: colors.NEUTRAL_50)
 * @param className - Additional CSS class name
 */
const DropdownIcon = ({
  size = 24,
  color = colors.NEUTRAL_50,
  className,
}: QuestionTypeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
    >
      <path
        d='M4.25 11C3.42 11 2.75 11.67 2.75 12.5C2.75 13.33 3.42 14 4.25 14C5.08 14 5.75 13.33 5.75 12.5C5.75 11.67 5.08 11 4.25 11ZM4.25 5C3.42 5 2.75 5.67 2.75 6.5C2.75 7.33 3.42 8 4.25 8C5.08 8 5.75 7.33 5.75 6.5C5.75 5.67 5.08 5 4.25 5ZM4.25 17C3.42 17 2.75 17.68 2.75 18.5C2.75 19.32 3.43 20 4.25 20C5.07 20 5.75 19.32 5.75 18.5C5.75 17.68 5.08 17 4.25 17ZM8.25 19.5H20.25C20.8 19.5 21.25 19.05 21.25 18.5C21.25 17.95 20.8 17.5 20.25 17.5H8.25C7.7 17.5 7.25 17.95 7.25 18.5C7.25 19.05 7.7 19.5 8.25 19.5ZM8.25 13.5H20.25C20.8 13.5 21.25 13.05 21.25 12.5C21.25 11.95 20.8 11.5 20.25 11.5H8.25C7.7 11.5 7.25 11.95 7.25 12.5C7.25 13.05 7.7 13.5 8.25 13.5ZM7.25 6.5C7.25 7.05 7.7 7.5 8.25 7.5H20.25C20.8 7.5 21.25 7.05 21.25 6.5C21.25 5.95 20.8 5.5 20.25 5.5H8.25C7.7 5.5 7.25 5.95 7.25 6.5Z'
        fill={color}
      />
    </svg>
  )
}

export default DropdownIcon
